import {HubConnection} from '@microsoft/signalr';
import {SignalRService} from '../signal-r.service';
import {ChatService} from '../../../../chat/services/chat.service';
import {UserService} from '../../../../user/services/user/user.service';
import {AuthService} from '../../../../auth/services/auth/auth.service';
import {TenantService} from '../../../../auth/services/tenant/tenant.service';
import {ChatMessage, ChatRoomCreatedDto} from '../../../../chat/models/createChatRoomRequest';
import {Subject} from 'rxjs';

export class ChatHandler {
  static instance: ChatHandler;
  connection: HubConnection;


  onReceive: Subject<ChatMessage> = new Subject<ChatMessage>();
  constructor(private signalRService: SignalRService,
              private chatService: ChatService,
              private userService: UserService,
              private authService: AuthService,
              private tenantService: TenantService) {
    ChatHandler.instance = this;
  }

  async hook(connection: HubConnection): Promise<void> {
    this.connection = connection;
    this.connection.on('ChatRoomCreated', this.onChatRoomCreated.bind(this));
    this.connection.on('ChatMessage', this.onChatMessage.bind(this));
  }

  private onChatRoomCreated(json: string) {
    const chatRoomCreatedDto = JSON.parse(json) as ChatRoomCreatedDto;
    const localUser = this.userService.currentUser;
    const localUserIsParticipant = chatRoomCreatedDto.participants.find(participant => participant === localUser.accountId);
    if (localUserIsParticipant) {
      this.connection.send('ConnectToChat', this.tenantService.tenantDto.tenant.id, this.authService.jwtToken, chatRoomCreatedDto.roomId);
      this.chatService.refreshChatRooms();
    }
  }

  private onChatMessage(json: string) {
    const chatMessage = JSON.parse(json) as ChatMessage;
    const chatRoom = this.chatService.chatRooms.find(room => room.room.id === chatMessage.chatId);
    if (chatRoom) {
      chatRoom.messages.push(chatMessage);
      this.onReceive.next(chatMessage);
    }
  }
}
